import React, { memo, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

import { useGetPageDeal } from '@hooks/useGetPageDeal';
import SiteSidebar from '@components/SiteSidebar';
import { sidebarStyle } from '@utils/theme';
import { AppState } from '@types';
import Blog from '@pages/Blog/Blog';
import PageContainer from '@components/PageContainer';
import PageDeal from './PageDeal';

type PagesProps = ReturnType<typeof mapStateToProps>;

function getSlug(url: string): string | null {
  const urlParts = url.split('/');
  const pIndex = urlParts.indexOf('p');

  if (pIndex !== -1 && pIndex < urlParts.length - 1) {
    return urlParts[pIndex + 1];
  }

  return null;
}
const Pages = ({ dealPageSEO }: PagesProps) => {
  const location = useLocation();
  const currentUrl = location.pathname;
  const slug = getSlug(currentUrl);

  const { data: pageDealData } = useGetPageDeal(slug);
  const [isCurrentListLoaded, setIsCurrentListLoaded] = useState(false);

  const handleCurrentListLoaded = () => {
    setIsCurrentListLoaded(true);
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          '@media (max-width: 900px)': {
            display: 'block'
          }
        }}
      >
        <Box
          sx={{
            width: '62%',
            '@media (max-width: 1200px)': {
              width: '59%'
            },
            '@media (max-width: 900px)': {
              width: '100%'
            }
          }}
        >
          <PageDeal
            pageDealData={pageDealData}
            dealPageSEO={dealPageSEO?.slug === slug ? dealPageSEO : null}
            onDealsLoaded={handleCurrentListLoaded} // Pass the callback function
          />
          {isCurrentListLoaded && (
            <PageContainer paddingTop="0" fullWidth>
              <Blog
                renderInContainer={false}
                shouldRenderSEO={false}
                filterOutSlug={slug}
              />
            </PageContainer>
          )}
        </Box>
        <Box sx={sidebarStyle}>
          <SiteSidebar />
        </Box>
      </Box>
    </Box>
  );
};

const mapStateToProps = ({ home: { dealPageSEO } }: AppState) => ({
  dealPageSEO
});

export default connect(mapStateToProps)(memo(Pages));
